'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _simpleBreakpoints = require('simple-breakpoints');

var _simpleBreakpoints2 = _interopRequireDefault(_simpleBreakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VueBreakpoint = {};

VueBreakpoint.install = function (Vue, breakpoints) {
    Vue.breakpoints = new _simpleBreakpoints2.default(breakpoints);

    Object.defineProperties(Vue.prototype, {

        $breakpoints: {
            get: function get() {
                return Vue.breakpoints;
            }
        }

    });
};

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(VueBreakpoint);
}

exports.default = VueBreakpoint;


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-simple-breakpoints/dist/index.js
// module id = 305
// module chunks = 0